module.exports = __webpack_public_path__ + "img/01.bc3b24f4.jpg";